export class User {
    public role: string;
    public name: string;
    public email: string;
}


// WEBPACK FOOTER //
// ./src/common/modules/user/models/User.ts